import { ITemplateFormData, IExtremeSetData } from '../models';

const extremeSetCheck = (extremeSet: IExtremeSetData) => {
	return Object.entries(extremeSet).every(
		([n, v]) => n === 'id' || (!v.error && v.text),
	);
};

export function isExtremeFormValid(data: Partial<ITemplateFormData>) {
	const { workStyleSlidersExtremes, performanceSlidersExtremes } = data;

	if (!workStyleSlidersExtremes?.length || !performanceSlidersExtremes?.length)
		return;
	return (
		workStyleSlidersExtremes.every(extremeSetCheck) &&
		performanceSlidersExtremes.every(extremeSetCheck)
	);
}
